import React from "react";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";

export default function RecursiveTreeView(props) {
  let dataArray = [];

  if (props.data) {
    for (let node in props.data) {
      dataArray.push(props.data[node]);
    }
  }

  function getChildren(nodeId) {
    let children = [];
    dataArray.forEach((node) => {
      if (node.parent === nodeId || (node.level === 1 && node.root === nodeId))
        children.push(node);
    });
    return children;
  }

  function change(id) {
    if (props.changeFn) props.changeFn(id);
  }

  const renderTree = (nodes) => {
    return (
      <TreeItem
        onClick={() => change(nodes.id)}
        key={nodes.id}
        nodeId={nodes.key + nodes.id}
        label={nodes.key}
        className="my-2"
      >
        {getChildren(nodes.id).map((node) => renderTree(node))}
      </TreeItem>
    );
  };

  return (
    <TreeView
      defaultCollapseIcon={<i className="fa fa-angle-down"></i>}
      defaultExpandIcon={<i className="fa fa-angle-right"></i>}
    >
      {Array.isArray(dataArray)
        ? dataArray.map((node) => (node.level === 0 ? renderTree(node) : null))
        : null}
    </TreeView>
  );
}
